/* Creator landing page (sections/creator-lp.liquid), 2026-09-28.
   1. the hero video card: a short clip attached after load, playing muted only while on screen; a tap scrolls to the
      full player and plays it with sound
   2. captions for the full player, from the section's cue list, when the video has none burned in
   3. one bag / two bags: one choice for the page; it rewrites both cards' lines, code and button, and the sticky bar
   4. add: /cart/add.js with the exact lines (selling plan per line), then the code without dropping codes already on the
      cart, then the drawer; the drawer's own form listener is stopped so nothing goes in twice
   5. sticky bar: on when the hero offer is off screen and the second offer is not in view; its button adds what it shows
   Chapters (desktop): the claims' timestamps as buttons that seek the full player */
(function () {
  var roots = document.querySelectorAll('[data-cl-root]');
  if (!roots.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var lite = !!conn.saveData || /(^|[^\d])2g/.test(conn.effectiveType || '');

  roots.forEach(function (root) {
    /* ---- 1. Video card ---- */
    var prev = root.querySelector('[data-cl-preview]');
    var full = root.querySelector('[data-cl-full]');
    /* The card's clip (a few seconds, ~200 KB) attaches after the page's load event; poster only on reduced motion or
       save-data. The full video loads only when someone taps Watch. */
    var attachPrev = function () {
      if (!prev || prev.getAttribute('src')) return;
      var ps = prev.getAttribute('data-src'); if (!ps) return;
      prev.preload = 'auto'; prev.src = ps;
      var r = prev.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) { var p = prev.play(); if (p && p.catch) p.catch(function () {}); }
    };
    if (prev && !reduce && !lite) {
      if (document.readyState === 'complete') attachPrev(); else window.addEventListener('load', attachPrev, { once: true });
    }
    if (prev && !reduce && !lite && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!prev.getAttribute('src')) return; var p = prev.play(); if (p && p.catch) p.catch(function () {}); }
          else prev.pause();
        });
      }, { threshold: 0.35 });
      io.observe(prev);
    }
    var watch = root.querySelector('[data-cl-watch]');
    if (watch && full) {
      watch.addEventListener('click', function () {
        if (prev) prev.pause();
        var box = full.closest('section') || full;
        box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        try { full.currentTime = 0; } catch (e) {}
        full.muted = false;
        var p = full.play(); if (p && p.catch) p.catch(function () {});
      });
    }

    /* Chapters (desktop): jump the full player to a moment, with sound */
    if (full) {
      var chaps = root.querySelectorAll('[data-cl-seek]');
      chaps.forEach(function (b) {
        b.addEventListener('click', function () {
          var t = parseFloat(b.getAttribute('data-cl-seek')) || 0;
          if (prev) prev.pause();
          try { full.currentTime = t; } catch (e) {}
          full.muted = false;
          var p = full.play(); if (p && p.catch) p.catch(function () {});
          var r = full.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) full.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
      });
      if (chaps.length) full.addEventListener('timeupdate', function () {
        var t = full.currentTime, on = null;
        chaps.forEach(function (b) { if (t >= (parseFloat(b.getAttribute('data-cl-seek')) || 0) - 0.2) on = b; });
        chaps.forEach(function (b) { b.classList.toggle('is-on', b === on); });
      });
    }

    /* ---- 2. Captions ---- */
    var capEl = root.querySelector('[data-cl-cap]');
    var cueEl = root.querySelector('[data-cl-cues]');
    if (full && capEl && cueEl) {
      var cues = [];
      try { cues = JSON.parse(cueEl.textContent || '[]'); } catch (e) { cues = []; }
      var last = -1;
      var sync = function () {
        var t = full.currentTime, idx = -1;
        for (var i = 0; i < cues.length; i++) { if (t >= cues[i][0] && t < cues[i][1] + 0.15) { idx = i; break; } }
        if (idx !== last) { last = idx; capEl.textContent = idx >= 0 ? cues[idx][2] : ''; }
      };
      full.addEventListener('timeupdate', sync);
      full.addEventListener('seeked', sync);
      full.addEventListener('ended', function () { capEl.textContent = ''; last = -1; });
    }

    /* ---- 3. One bag / two bags ----
       One choice for the whole page: the hero card, the lower card and the sticky bar follow it. */
    var setForm = function (form, opt) {
      if (!form) return;
      form.setAttribute('data-cl-items', opt.getAttribute('data-items'));
      /* the two-bag option may carry its own code (10% off two bags); one bag carries none */
      var oc = opt.getAttribute('data-code') || '';
      if (oc) form.setAttribute('data-cl-code', oc); else form.removeAttribute('data-cl-code');
      var q = form.querySelector('input[name="quantity"]');
      if (q) q.value = opt.value;
    };
    var applyOpt = function (opt) {
      root.querySelectorAll('[data-cl-opt]').forEach(function (o) {
        if (o.value !== opt.value) return;
        if (!o.checked) o.checked = true;
        var card = o.closest('.cl-offer');
        var form = card && card.querySelector('[data-cl-form]');
        setForm(form, o);
        var btn = form && form.querySelector('[data-cl-cta]');
        if (btn && !btn.disabled) btn.textContent = o.getAttribute('data-cta');
      });
      var bf = root.querySelector('[data-cl-bar-form]');
      setForm(bf, opt);
      var bp = root.querySelector('[data-cl-bar-price]'), bl = root.querySelector('[data-cl-bar-label]');
      if (bp) bp.textContent = opt.getAttribute('data-price') || '';
      if (bl) bl.textContent = opt.getAttribute('data-bar') || '';
    };
    root.querySelectorAll('[data-cl-opt]').forEach(function (opt) {
      opt.addEventListener('change', function () { if (opt.checked) applyOpt(opt); });
    });

    /* ---- 4. Add ---- */
    var JSONH = { 'Accept': 'application/json' };
    function getCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: JSONH }).then(function (r) { return r.json(); }); }
    function applyCode(code) {
      code = String(code || '').trim();
      if (!code) return getCart();
      return getCart().then(function (c) {
        var codes = [];
        (c.discount_codes || []).forEach(function (d) { if (d && d.code && codes.indexOf(d.code) < 0) codes.push(d.code); });
        if (codes.map(function (x) { return String(x).toUpperCase(); }).indexOf(code.toUpperCase()) >= 0) return c;
        codes.push(code);
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) }).then(function (r) { return r.json(); });
      });
    }
    function readItems(form) {
      var items = [];
      (form.getAttribute('data-cl-items') || '').split(',').forEach(function (t) {
        var f = t.split(':'); var id = parseInt(f[0], 10), q = parseInt(f[1], 10) || 1, plan = parseInt(f[2], 10) || 0;
        if (id > 0) { var it = { id: id, quantity: q }; if (plan > 0) it.selling_plan = plan; items.push(it); }
      });
      return items;
    }
    function openCart() {
      var d = window.AnaerobicCartDrawer;
      if (d && typeof d.open === 'function') { try { d.open('creator-lp'); return; } catch (e) {} }
      window.location.href = '/cart';
    }
    root.addEventListener('submit', function (ev) {
      var form = ev.target && ev.target.closest && ev.target.closest('[data-cl-form]');
      if (!form) return;
      ev.preventDefault();
      ev.stopPropagation();
      var btn = form.querySelector('button');
      var items = readItems(form);
      if (!items.length || (btn && btn.disabled)) return;
      var code = form.getAttribute('data-cl-code') || '';
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; }
      var added = false;
      /* Cart speed (2026-09-28): open the drawer at the tap ("Adding…" row) and fill it with the cart the chain holds. */
      var dr = window.AnaerobicCartDrawer, early = false;
      if (dr && typeof dr.open === 'function' && typeof dr.render === 'function') { try { dr.open('creator-lp', { pending: true }); early = true; } catch (e) { early = false; } }
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) { var e = new Error('add ' + r.status); e.status = r.status; throw e; } added = true; return r.json(); })
        .then(function () { return code ? applyCode(code).catch(function () { return null; }) : null; })
        .then(function (c) {
          if (btn) { btn.removeAttribute('aria-busy'); btn.classList.add('is-added'); btn.textContent = 'Added'; }
          setTimeout(function () { if (btn) { btn.classList.remove('is-added'); btn.innerHTML = label; btn.disabled = false; } }, 1800);
          if (early) dr.render(c); else openCart();
        })
        .catch(function (err) {
          if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; btn.innerHTML = label; }
          if (added) { if (early) { dr.refresh(); return; } window.location.href = '/cart'; return; }
          if (early) { try { dr.close(); } catch (e) {} }
          if (err && err.status === 422) { if (btn) { btn.textContent = 'Sold out'; btn.disabled = true; } return; }
          form.submit();
        });
    }, true);

    /* ---- 5. Sticky bar ---- */
    var bar = root.querySelector('[data-cl-bar]');
    var hero = root.querySelector('[data-cl-heroffer]');
    var again = root.querySelector('.cl-again');
    if (bar && hero) {
      var ticking = false;
      var setBar = function () {
        ticking = false;
        var vh = window.innerHeight;
        var h = hero.getBoundingClientRect();
        var heroGone = h.bottom < 80;
        var a = again ? again.getBoundingClientRect() : null;
        var againIn = a ? (a.top < vh * 0.9 && a.bottom > vh * 0.1) : false;
        var on = heroGone && !againIn;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      };
      var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(setBar); } };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      setBar();
    }
  });
})();
